<template>
  <div class="fill-height">
    <v-container v-if="error" fill-height>
      <Error />
    </v-container>

    <div v-else>
      <v-row class="ma-0 pa-4">
        <v-col cols="12" md="8" lg="9">
          <my-profile-list :showGraph="false" :vertical="false" class="mb-10" />

          <basic-info @onError="snackbar = true" class="mb-10" />

          <template v-if="!isPublicProfile">
            <ongoing-course-list
              :data="onGoingCourses"
              :loading="loading"
              class="mb-10"
            />

            <assigned-course-list
              :data="assignedCourses"
              :loading="loading"
              class="mb-10"
            />
          </template>
        </v-col>

        <v-col cols="12" md="4" lg="3">
          <ProfileQrCode v-if="!isPublicProfile" class="mb-10" />

          <achievement-list :vertical="true" class="mb-10" />
        </v-col>
      </v-row>
    </div>

    <v-snackbar v-model="snackbar" timeout="3000">
      {{ $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="snackbar = false">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Error from "../../core-module/components/Error.vue";
import MyProfileList from "../components/Dashboard/MyProfileList";
import OngoingCourseList from "../../course-module/components/OngoingCourseList.vue";
import AssignedCourseList from "../../course-module/components/AssignedCourseList.vue";
import AchievementList from "../../user-module/components/Dashboard/AchievementList.vue";
import ProfileQrCode from "../components/ProfileQrCode";
import BasicInfo from "../components/BasicInfo.vue";

export default {
  components: {
    ProfileQrCode,
    Error,
    MyProfileList,
    OngoingCourseList,
    AssignedCourseList,
    AchievementList,
    BasicInfo,
  },
  data() {
    return {
      snackbar: false,
      loading: true,
      error: false,
      variables: {
        limit: 0,
        skip: 0,
      },
      filterInput: {
        dateFrom: "",
        dateTo: "",
      },
      onGoingCourses: [],
      assignedCourses: [],
    };
  },
  computed: {
    isPublicProfile() {
      return this.$route.name === "PublicProfile";
    },
  },
  apollo: {
    getTrainingRegistrations() {
      return {
        query: require("../../course-module/api/query/getTrainingRegistrations.gql"),
        variables: {
          limit: this.variables.limit,
          skip: this.variables.skip,
        },
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingRegistrations &&
            data.getTrainingRegistrations.trainingRegistrations
          ) {
            this.onGoingCourses = [];
            this.assignedCourses = [];

            data.getTrainingRegistrations.trainingRegistrations.map(obj => {
              if (obj.status === "STARTED") {
                this.onGoingCourses.push(obj);
              } else if (obj.status === "REGISTERED") {
                this.assignedCourses.push(obj);
              }
            });
          } else if (!this.isPublicProfile) {
            this.error = true;
          }

          this.loading = loading;
        },
        skip() {
          return this.isPublicProfile;
        },
      };
    },
  },
};
</script>
